import ngTableSelectAllHeaderTemplate from './ng-table/selectAllHeader.html';
import ngTablePagerTemplate from './ng-table/pager.html';
import ngTableHelpTextHeaderTemplate from './ng-table/helptextHeaderCell.html';
import uiSelectBootstrapMatchTemplate from './ui-select/bootstrap/match.tpl.html';

export default angular.module('app.templates', [])
  .run(function($templateCache) {
    $templateCache.put('ng-table/pager.html', ngTablePagerTemplate);
    $templateCache.put("ng-table/selectAllHeader.html", ngTableSelectAllHeaderTemplate);
    $templateCache.put("ng-table/helptextHeaderCell.html", ngTableHelpTextHeaderTemplate);
    $templateCache.put("bootstrap/match.tpl.html", uiSelectBootstrapMatchTemplate);
  })


/** WEBPACK FOOTER **
 ** ./src/templates/templates.js
 **/